
import { AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { _AbcTreeComponent, _AbcTreeNode } from '@barthauer/abc/ui-components/abc-tree';
import { Subject } from 'rxjs';
import { ProtocolViewerService } from '../../protocol-viewer.service';

@Component({
    selector: 'protocol-category-list',
    templateUrl: './category-list.component.html',
    styleUrls: ['./category-list.component.scss'],
    imports: [_AbcTreeComponent]
})
export class CategoryListComponent implements OnInit, OnDestroy, AfterViewInit {
  @ViewChild('categoryListTree') categoryListTree: _AbcTreeComponent;
  protected categoryList: _AbcTreeNode<string>[];
  @Input() categoryDescription: string;

  private $unsubscribe = new Subject();

  constructor(private protocolViewerService: ProtocolViewerService) {}

  ngOnInit(): void {
    this.categoryList = this.protocolViewerService.categoryList;
  }

  ngOnDestroy(): void {
    this.$unsubscribe.next(null);
    this.$unsubscribe.complete();
  }

  ngAfterViewInit(): void {
    this.categoryListTree?.instance.selectItem(this.categoryList[0]?.id);
  }
}
